{
  "executiveSummary": "Coogo 문서 생성은 Golden Template의 필수 슬롯을 입력 값에 일대일로 매핑하고, 동일한 결정론적 writer로 DOCX와 PDF를 생성한다. 규칙 전용 arm은 사전에 정의된 항목만 배치하며 의미의 재구성이나 우선순위 판단은 수행하지 않는다.",
  "pricingTable": [
    {
      "label": "Template",
      "value": "승격된 manifest, 입력 schema, 필수 slot 순서를 그대로 적용",
      "evidenceRef": "source://golden-template"
    },
    {
      "label": "Compiler",
      "value": "동일 IR에서 DOCX와 PDF를 생성하고 모델의 직접 쓰기를 금지",
      "evidenceRef": "source://deterministic-gates"
    },
    {
      "label": "Verification",
      "value": "schema, slot coverage, output hash, openability, structural readback 확인",
      "evidenceRef": "source://verified-outcomes"
    }
  ]
}
